import { combineReducers } from 'redux';

import appinfoReducer from './appinfo.reducer';
import approvedTransactionsReducer from './approved.transactions.reducer';
import authReducer from './auth.reducer';
import customersReducer from './customers.reducer';
import dashboardReducer from './dashboard.reducer';
import designationReducer from './designation.reducer';
import staffsReducer from './staffs.reducer';
import unApprovedTransactionsReducer from './unapproved.transactions.reducer';

const reducers = combineReducers({
  auth: authReducer,
  appInfo: appinfoReducer,
  designations: designationReducer,
  staffs: staffsReducer,
  unapproved: unApprovedTransactionsReducer,
  approved: approvedTransactionsReducer,
  customers: customersReducer,
  dashboard: dashboardReducer
});

export default reducers;
